import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SelectPromptTemplateComponent } from 'src/app/middleware/common/selectPromptTemplate/selectPromptTemplate.component';
import { SelectFieldTemplateComponent } from 'src/app/middleware/common/selectFieldTemplate/selectFieldTemplate.component';

@Component({
  selector: 'app-manage-AIAutomationTemplates',
  templateUrl: './manage-AIAutomationTemplates.component.html',
  styleUrls: ['./manage-AIAutomationTemplates.component.scss']
})

export class ManageAIAutomationComponent implements OnInit {

  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList:[],
    officeID:0   
  };
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  folderList: any[]=[];  
  value = ''; 
  paginatorTotalLength: any;
  //dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  spinner:boolean=false;
  taskStatusID:number=0;

  cType:number=1;
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  menuModulesList: any = [] = [];
  folderID:number=0;
  FormReportfolderList: any = [] = [];
  ShowNoRecordFoundForms:boolean=false;
  databaseId:any;
  templateName:string="";
  aITemplateList: any = [] = [];
  filterText:string="";
  aiAutomationTemplateID:number=0;
  showAddUpdateButton:boolean=true;
  PromptTemplateName:string="";
  PromptTemplateID:number=0;
  FieldTemplateName:string="";
  FieldTemplateID:number=0;
  TitleName:string="Add";

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
     private toastr: ToastrService, private statusConst: StatusConstant, 
     private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    this.getAIAutomationTemplates(); 
  } 
  
  getAIAutomationTemplates() {
    this.loaderService.show();   
    var ReqModel = {
      keyword:this.filterText,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID:Number(this.databaseId)
     }
    this.settingsService.getAIAutomationTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.aITemplateList = this.responseHolder.data.templates;
          if(this.aITemplateList==null){
            this.aITemplateList=[];
          }         
          if(this.aITemplateList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.aITemplateList=[];      
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.aITemplateList=[];     
        this.loaderService.hide();
      }
    });
  } 


  selectPromptTemplate(data:any){
    const dialogRef = this.dialog.open(SelectPromptTemplateComponent, {    
     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.aiAutomationTemplateID =data.aiAutomationTemplateID;

        this.PromptTemplateID = result.templateID;        
        this.FieldTemplateID=data.fieldTemplateID;
        this.templateName= data.name;
        this.addAIAutomationTemplate();  
      }
    }); 
  }
  

  selectFieldTemplate(data:any){
    const dialogRef = this.dialog.open(SelectFieldTemplateComponent, {    
     
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.aiAutomationTemplateID =data.aiAutomationTemplateID;

        this.FieldTemplateID = result.templateID;
        this.PromptTemplateID=data.promptTemplateID;
        this.templateName= data.name;
        this.addAIAutomationTemplate();
      }
    }); 
  }

  openAddTemplates(templateRef: TemplateRef<any>) {
    this.aiAutomationTemplateID=0;
    this.TitleName="Add";
    this.templateName="";

    this.FieldTemplateName="";
    this.FieldTemplateID=0;

    this.PromptTemplateName="";
    this.PromptTemplateID=0;
   // this.dialog.open(templateRef);   

     this.dialog.open(templateRef, {
       panelClass: 'selectTemplate',
     });   

   
  }
    
  closeUpdate(){
    this.templateName="";
    this.FieldTemplateName="";
    this.FieldTemplateID=0;

    this.PromptTemplateName="";
    this.PromptTemplateID=0;
    this.dialog.closeAll();
  }

  onChangeTemplateName(searchValue: string): void {  
    if(searchValue==""){
      this.showAddUpdateButton=true;
    }else{
      this.showAddUpdateButton=false;
    }
  }

  addAIAutomationTemplate(){
    if(this.templateName==""){
      this.toastr.warning('Please Enter Template Name.', '', {
        timeOut: 3000,
      });
      return;
    }    
    this.loaderService.show();   
    var ReqModel = {
      aiAutomationTemplateID:this.aiAutomationTemplateID,
      name: this.templateName,
      fieldTemplateID: this.FieldTemplateID,
      promptTemplateID: this.PromptTemplateID,
      formID: 0,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID:Number(this.databaseId)
     }
    this.settingsService.addAIAutomationTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if(this.aiAutomationTemplateID==0){
            this.toastr.success('Record saved successfully.', '', {
              timeOut: 3000,
            });
          }
          if(this.aiAutomationTemplateID>0){
            this.toastr.success('Record update successfully.', '', {
              timeOut: 3000,
            });
          }
          this.filterText = "";
          this.getAIAutomationTemplates();
          this.closeUpdate();
        }else {           
          this.loaderService.hide();
        }
      }
      else {         
        this.loaderService.hide();
      }
    });
  }

  deleteAIAutomationTemplate(data: any) { 
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel ={
          aiAutomationTemplateID: data.aiAutomationTemplateID,  
          userID: this.currentUser.UID,        
          organizationID: Number(this.organizationId),  
          databaseID:Number(this.databaseId),         
          officeID:this.myOfficeID,
        }        
        this.settingsService.removeAutomationTemplate(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Record deleted successfully.', '', {
                timeOut: 3000,
              });
              this.filterText = "";
              this.getAIAutomationTemplates();
              this.loaderService.hide();
            }
          }
        });
      }
    });
  }  

  Search(filterValue) {
    this.filterText = filterValue;
    this.pageModelData.searchValue = filterValue;
    this.getAIAutomationTemplates();
   }

  clearFilter(){
    this.value = "";
    this.filterText = "";
    this.pageModelData.searchValue = this.filterText;
    this.getAIAutomationTemplates();
   }

 
   UpdateAITempDialog(templateRef: TemplateRef<any>, data: any) {    
    this.aiAutomationTemplateID=data.aiAutomationTemplateID;
    this.FieldTemplateID=data.fieldTemplateID;
    this.PromptTemplateID=data.promptTemplateID;

    this.TitleName="Rename";
    this.showAddUpdateButton=true;

    this.templateName= data.name;
    //this.FieldTemplateName=data.fieldTemplateName;
    //this.PromptTemplateName=data.promptTemplateName;

    this.dialog.open(templateRef);    
   } 
   
   removeFieldTemplate(data: any) { 
    var message = `Are you sure you want to remove selected Field Template?`;  
    const title = `Confirm Remove`;
    const confirm = `Remove`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel = {
          aiAutomationTemplateID:data.aiAutomationTemplateID,
          name: data.name,
          fieldTemplateID: 0,
          promptTemplateID: data.promptTemplateID,
          formID: 0,
          userID: this.currentUser.UID,
          officeID: this.myOfficeID,
          organizationID: Number(this.organizationId),
          databaseID:Number(this.databaseId)
         }
        this.settingsService.addAIAutomationTemplate(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {              
               this.toastr.success('Selected Field Template remove successfully.', '', {
                  timeOut: 3000,
               });      
              this.filterText = "";
              this.getAIAutomationTemplates();
              this.closeUpdate();
            }else {           
              this.loaderService.hide();
            }
          }
          else {         
            this.loaderService.hide();
          }
        });
      }
    });
  } 

   removePromptTemplate(data: any) { 
    var message = `Are you sure you want to remove selected Question Template?`;  
    const title = `Confirm Remove`;
    const confirm = `Remove`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel = {
          aiAutomationTemplateID:data.aiAutomationTemplateID,
          name: data.name,
          fieldTemplateID: data.fieldTemplateID,
          promptTemplateID: 0,
          formID: 0,
          userID: this.currentUser.UID,
          officeID: this.myOfficeID,
          organizationID: Number(this.organizationId),
          databaseID:Number(this.databaseId)
         }
        this.settingsService.addAIAutomationTemplate(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {              
               this.toastr.success('Selected Question Template remove successfully.', '', {
                  timeOut: 3000,
               });      
              this.filterText = "";
              this.getAIAutomationTemplates();
              this.closeUpdate();
            }else {           
              this.loaderService.hide();
            }
          }
          else {         
            this.loaderService.hide();
          }
        });
      }
    });
  } 

}

